"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initSuggestionsKindRegistry = void 0;
const types_1 = require("../types");
// Registry of possible suggestions for the given statement position
const initSuggestionsKindRegistry = () => {
    return [
        {
            id: types_1.StatementPosition.SelectKeyword,
            name: types_1.StatementPosition.SelectKeyword,
            kind: [types_1.SuggestionKind.SelectKeyword],
        },
        {
            id: types_1.StatementPosition.WithKeyword,
            name: types_1.StatementPosition.WithKeyword,
            kind: [types_1.SuggestionKind.WithKeyword],
        },
        {
            id: types_1.StatementPosition.AfterSelectKeyword,
            name: types_1.StatementPosition.AfterSelectKeyword,
            kind: [
                types_1.SuggestionKind.StarWildCard,
                types_1.SuggestionKind.FunctionsWithArguments,
                types_1.SuggestionKind.Columns,
                types_1.SuggestionKind.SelectMacro,
            ],
        },
        {
            id: types_1.StatementPosition.AfterSelectFuncFirstArgument,
            name: types_1.StatementPosition.AfterSelectFuncFirstArgument,
            kind: [types_1.SuggestionKind.Columns],
        },
        {
            id: types_1.StatementPosition.AfterGroupByFunctionArgument,
            name: types_1.StatementPosition.AfterGroupByFunctionArgument,
            kind: [types_1.SuggestionKind.Columns],
        },
        {
            id: types_1.StatementPosition.AfterWhereFunctionArgument,
            name: types_1.StatementPosition.AfterWhereFunctionArgument,
            kind: [types_1.SuggestionKind.Columns],
        },
        {
            id: types_1.StatementPosition.AfterSelectArguments,
            name: types_1.StatementPosition.AfterSelectArguments,
            kind: [types_1.SuggestionKind.Columns],
        },
        {
            id: types_1.StatementPosition.AfterFromKeyword,
            name: types_1.StatementPosition.AfterFromKeyword,
            kind: [types_1.SuggestionKind.Schemas, types_1.SuggestionKind.Tables, types_1.SuggestionKind.TableMacro],
        },
        {
            id: types_1.StatementPosition.AfterSchema,
            name: types_1.StatementPosition.AfterSchema,
            kind: [types_1.SuggestionKind.Tables, types_1.SuggestionKind.TableMacro],
        },
        {
            id: types_1.StatementPosition.SelectAlias,
            name: types_1.StatementPosition.SelectAlias,
            kind: [types_1.SuggestionKind.Columns, types_1.SuggestionKind.FunctionsWithArguments],
        },
        {
            id: types_1.StatementPosition.FromKeyword,
            name: types_1.StatementPosition.FromKeyword,
            kind: [types_1.SuggestionKind.FromKeyword],
        },
        {
            id: types_1.StatementPosition.AfterFrom,
            name: types_1.StatementPosition.AfterFrom,
            kind: [
                types_1.SuggestionKind.WhereKeyword,
                types_1.SuggestionKind.GroupByKeywords,
                types_1.SuggestionKind.OrderByKeywords,
                types_1.SuggestionKind.LimitKeyword,
            ],
        },
        {
            id: types_1.StatementPosition.AfterTable,
            name: types_1.StatementPosition.AfterTable,
            kind: [
                types_1.SuggestionKind.WhereKeyword,
                types_1.SuggestionKind.GroupByKeywords,
                types_1.SuggestionKind.OrderByKeywords,
                types_1.SuggestionKind.LimitKeyword,
            ],
        },
        {
            id: types_1.StatementPosition.WhereKeyword,
            name: types_1.StatementPosition.WhereKeyword,
            kind: [types_1.SuggestionKind.Columns, types_1.SuggestionKind.FilterMacro, types_1.SuggestionKind.TemplateVariables],
        },
        {
            id: types_1.StatementPosition.WhereComparisonOperator,
            name: types_1.StatementPosition.WhereComparisonOperator,
            kind: [types_1.SuggestionKind.ComparisonOperators],
        },
        {
            id: types_1.StatementPosition.WhereValue,
            name: types_1.StatementPosition.WhereValue,
            kind: [types_1.SuggestionKind.FilterMacro, types_1.SuggestionKind.TemplateVariables],
        },
        {
            id: types_1.StatementPosition.AfterWhereValue,
            name: types_1.StatementPosition.AfterWhereValue,
            kind: [
                types_1.SuggestionKind.LogicalOperators,
                types_1.SuggestionKind.GroupByKeywords,
                types_1.SuggestionKind.OrderByKeywords,
                types_1.SuggestionKind.LimitKeyword,
                types_1.SuggestionKind.Columns,
                types_1.SuggestionKind.TemplateVariables,
            ],
        },
        {
            id: types_1.StatementPosition.AfterGroupByKeywords,
            name: types_1.StatementPosition.AfterGroupByKeywords,
            kind: [types_1.SuggestionKind.GroupMacro, types_1.SuggestionKind.Columns],
        },
        {
            id: types_1.StatementPosition.AfterGroupBy,
            name: types_1.StatementPosition.AfterGroupBy,
            kind: [types_1.SuggestionKind.OrderByKeywords, types_1.SuggestionKind.LimitKeyword],
        },
        {
            id: types_1.StatementPosition.AfterOrderByKeywords,
            name: types_1.StatementPosition.AfterOrderByKeywords,
            kind: [types_1.SuggestionKind.Columns],
        },
        {
            id: types_1.StatementPosition.AfterOrderByFunction,
            name: types_1.StatementPosition.AfterOrderByFunction,
            kind: [types_1.SuggestionKind.SortOrderDirectionKeyword, types_1.SuggestionKind.LimitKeyword],
        },
        {
            id: types_1.StatementPosition.AfterOrderByDirection,
            name: types_1.StatementPosition.AfterOrderByDirection,
            kind: [types_1.SuggestionKind.LimitKeyword],
        },
        {
            id: types_1.StatementPosition.AfterIsOperator,
            name: types_1.StatementPosition.AfterOrderByDirection,
            kind: [types_1.SuggestionKind.NotKeyword, types_1.SuggestionKind.NullValue, types_1.SuggestionKind.BoolValues],
        },
        {
            id: types_1.StatementPosition.AfterIsNotOperator,
            name: types_1.StatementPosition.AfterOrderByDirection,
            kind: [types_1.SuggestionKind.NullValue, types_1.SuggestionKind.BoolValues],
        },
    ];
};
exports.initSuggestionsKindRegistry = initSuggestionsKindRegistry;
//# sourceMappingURL=suggestionsKindRegistry.js.map